<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Movimiento de Inventario por Doc. Electrónico
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Movimiento de Inventario por Doc. Electrónico</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <div class="row filtros-body">
      <div class="col" style="max-width: 200px;">
        <div class="md-form mb-0">
          <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required></mdb-date-picker>
        </div>
      </div>

      <div class="col" style="max-width: 200px;">
        <div class="md-form mb-0">
          <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required></mdb-date-picker>
        </div>
      </div>
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
            placeholder="Seleccionar Estado"></mdb-select>
          <label>Estado</label>
        </div>
      </div>
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <mdb-select [options]="optionsTipDocumento" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
            placeholder="Seleccionar Tipo Documento"></mdb-select>
          <label>Tipo de Documento</label>
        </div>
      </div>
    </div>


    <div class="row filtros-body">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="rutprovedor" class="form-control" placeholder="9.999.999-9" required
            #rutprovedor />
          <label for="rutprovedor">Rut de Proveedores</label>
        </div>
      </div>
      <div class="col d-flex" style="max-width: 300px;">
        <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
          (click)="seleccionarProveedor.show()">
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents;">
          Nombre del proveedor
        </h6>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="nrodoc" class="form-control" placeholder="9.999.999-9" required #nrodoc />
          <label for="nrodoc">Nro. Documento</label>
        </div>
      </div>
      <div class="col d-flex" style="max-width: 300px;">
        <button mdbBtn type="button" class="btn-cuadrado" color="info" mdbWavesEffect
          (click)="consultaMovimiento.show()">
          <mdb-icon fas icon="eye"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents;">
          Algun dato del Doc.
        </h6>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Resumen</th>
            <th scope="col">Nro. Mov.</th>
            <th scope="col">Nro. Doc.</th>
            <th scope="col">Fecha</th>
            <th scope="col">Tipo Doc.</th>
            <th scope="col">Folio</th>
            <th scope="col">RUT</th>
            <th scope="col">Proveedor</th>
            <th scope="col" style="text-align: right;">Monto</th>
            <th scope="col">Fecha Atención</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="consultaMovimiento.show()" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>100023</td>
            <td>112412124</td>
            <td>02/02/2020</td>
            <td>Factura Manual</td>
            <td>0000000000000000000123</td>
            <td>9.999.999-9</td>
            <td>COmercial OLEU</td>
            <td align="right">1.000.000</td>
            <td>02/02/2020</td>
            <td>
              <mdb-badge pill="true" success="true">Atendido</mdb-badge>
            </td>
          </tr>
          <tr>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="consultaMovimiento.show()" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>100023</td>
            <td>112412124</td>
            <td>02/02/2020</td>
            <td>Factura Manual</td>
            <td>0000000000000000000123</td>
            <td>9.999.999-9</td>
            <td>COmercial OLEU</td>
            <td align="right">1.000.000</td>
            <td>02/02/2020</td>
            <td>
              <mdb-badge pill="true" info="true">Pendiente</mdb-badge>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<div mdbModal #seleccionarProveedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar proveedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarProveedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="rutVend" class="form-control" placeholder="Nombre o RUT del vendedor"
                required #rutVend />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px;">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarProveedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL ver movimiento -->
<div mdbModal #consultaMovimiento="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Movimiento de inventario por Documentos Electrónico MES PROCESO - AÑO
          PROCESO
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="consultaMovimiento.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center">
          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Fecha de movimiento</Strong>
            <span class="value">15/02/2020</span>
          </div>

          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Estado</Strong>
            <span class="value">
              <mdb-badge pill="true" info="true">Pendiente</mdb-badge>
            </span>
          </div>

          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Tipo</Strong>
            <span class="value">Factura</span>
          </div>

          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Nro. Doc.</Strong>
            <span class="value">Factura</span>
          </div>
        </div>

        <div class="row">
          <div class="col" style="max-width: 300px;">
            <div class="md-form">
              <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Seleccionar Bodega"></mdb-select>
              <label>Bodega</label>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="referencia" class="form-control" placeholder="Referencia" required
                #referencia />
              <label for="rutcliente">Referencia</label>
            </div>
          </div>
        </div>



        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox></mdb-checkbox>
              </th>
              <th scope="col">SKU</th>
              <th scope="col">Producto</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-right">Cantidad Und.</th>
              <th scope="col">Cantidad recibida</th>
              <th scope="col" class="text-right">Diferencia</th>
              <th scope="col" class="text-right">Costo unitario</th>
              <th scope="col" class="text-right">Costo total</th>
              <th scope="col">Formato TOP</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <mdb-checkbox></mdb-checkbox>
              </td>
              <td>1231232128</td>
              <td>Cassata</td>
              <td>PALLET</td>
              <td class="text-right">5</td>
              <td>

                <div style="max-width: 100px;">
                  <input value="" type="text" id="cantDevolucion" class="form-control" placeholder="000" required
                    #cantDevolucion />
                </div>

              </td>
              <td class="text-right"></td>
              <td class="text-right">300.000</td>
              <td class="text-right">600.000</td>
              <td>
                <div class="md-form m-0">
                  <mdb-select [options]="optionsFormato" placeholder="Formato" [filterEnabled]="true"></mdb-select>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody class="blue lighten-5">
            <tr>
              <td align="right" colspan="4">
                <strong>Total</strong>
              </td>
              <td align="right"><strong>16</strong></td>
              <td align="right"><strong>15</strong></td>
              <td align="right"><strong>1</strong></td>
              <td align="right"><strong>760.000</strong></td>
              <td align="right"><strong>1.160.000</strong></td>
              <td align="right"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="consultaMovimiento.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <div class="">
          <button size="sm" type="button" class="btn btn-sm btn-success waves-light" mdbWavesEffect
            (click)="consultaMovimiento.hide()">
            Imprimir
          </button>
          <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
            (click)="consultaMovimiento.hide()">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<div mdbModal #seleccionarProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar producto
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarProducto.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="descCodeProduct" class="form-control" placeholder="Descripción o Código"
                required #descCodeProduct />
              <label for="descCodeProduct">Descripción o Código</label>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <mdb-select label="Categoria" placeholder="Categoria" [options]="optionsCategoria" [filterEnabled]="true">
              </mdb-select>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <mdb-select label="Familia" placeholder="Familia" [options]="optionsFamilia" [filterEnabled]="true">
              </mdb-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col dato" style="display: flex; align-items: center; min-width: 240px;">
            <!-- Switch -->
            <div class="switch danger-switch">
              <label>
                Inactivo
                <input type="checkbox" />
                <span class="lever"></span>
                Activo
              </label>
            </div>
          </div>
          <div class="col dato" style="min-width: 350px; display: flex; align-items: center;">
            <!-- Material inline 1 -->
            <div class="form-check form-check-inline" style="margin-right: 20px;">
              <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
                mdbInput />
              <label class="form-check-label" for="materialInline1">Afecto</label>
            </div>

            <!-- Material inline 2 -->
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
                mdbInput />
              <label class="form-check-label" for="materialInline2">Exento</label>
            </div>
          </div>
        </div>

        <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
          <div></div>
          <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect>
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>

        <table class="table table-striped table-hover table-sm align-middle mt-1">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Descripción</th>
              <th scope="col">Familia</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0105234234</td>
              <td>Cassata Piña 1Lt. savory</td>
              <td>helados</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProducto.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>0105234234</td>
              <td>Cassata Piña 1Lt. savory</td>
              <td>helados</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProducto.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>0105234234</td>
              <td>Cassata Piña 1Lt. savory</td>
              <td>helados</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                  (click)="seleccionarProducto.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>